import { useEffect, useState } from 'react'
import {
  fetchAndActivateRemoteConfig,
  getChatPresenceEnsureFromRemote,
} from 'configs/firebase'

import { useChatHistoryAsSource } from './useChatHistoryAsSource'

/**
 * Fase 4 — presença gerida pelo backend.
 *
 * **Depende da Fase 3, e a dependência é aplicada aqui, não confiada ao
 * operador.** A spec é explícita: sem o histórico vindo da API, remover a
 * participação do profissional o deixa sem leitura de dado clínico. Ligar
 * `chat_presence_ensure` sozinha, por engano de configuração, produziria
 * exatamente esse estado — então a flag só vale acompanhada de
 * `chat_history_as_source`.
 */
export function useChatPresenceEnsure(): boolean {
  const historyAsSource = useChatHistoryAsSource()
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    let cancelled = false
    void (async () => {
      await fetchAndActivateRemoteConfig()
      if (cancelled) return
      setEnabled(getChatPresenceEnsureFromRemote())
    })()
    return () => {
      cancelled = true
    }
  }, [])

  return enabled && historyAsSource
}
